<template>
  <div class="ios-glass-page">
    <!-- 1. 背景光斑动画 -->
    <div class="background-blobs">
      <div class="blob blob-1"></div>
      <div class="blob blob-2"></div>
    </div>

    <!-- 2. 页面头部 -->
    <!-- <div class="page-header">
      <h2 class="header-title">视讯控制台</h2>
      <div class="header-subtitle">Device Control Center</div>
    </div> -->

    <!-- 3. 当前设备主卡片 (点击呼出弹窗) -->
    <div class="section-label">当前控制设备</div>
    <div class="current-device-card glass-container" @click="openDevicePopup">
      <div class="card-content">
        <!-- 左侧图标状态 -->
        <div class="device-icon-box" :class="{ 'online': isOnline(deviceData) }">
          <van-icon name="desktop-o" size="24" color="#fff" />
          <div class="pulse-ring" v-if="isOnline(deviceData)"></div>
        </div>
        
        <!-- 中间信息 -->
        <div class="device-info">
          <div class="device-name">
            {{ deviceData.remark || '请点击选择设备' }}
          </div>
          <div class="device-status-text">
            <span v-if="deviceData.code">IP: {{ deviceData.ip || '--' }}</span>
            <span v-else>点击切换</span>
            <span class="dot" v-if="deviceData.code">·</span>
            <span :class="isOnline(deviceData) ? 'text-green' : 'text-gray'">
              {{ formatStatus(deviceData) }}
            </span>
          </div>
        </div>

        <!-- 右侧切换按钮 -->
        <div class="switch-btn">
          <span>切换</span>
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
      <!-- 空状态 -->
      <div v-if="!isVideoPlay && deviceData.code" class="glass-container empty-state">
        <van-icon name="info-o" size="40" color="#8e8e93" />
        <p>当前设备模式不是视讯，无法切换视频</p>
        <p class="sub-tip">请先在跳跳乐园中切换为“视讯项目”</p>
      </div>

       <div v-else-if="!deviceData.code" class="glass-container empty-state">
        <van-icon name="desktop-o" size="40" color="#007AFF" />
        <p>请先在上方选择一个设备</p>
      </div>

    <!-- 4. 视讯内容区域 -->
    <!-- <div class="section-label">视讯内容列表</div> -->
    <div v-else class="video-container">
      <!-- 状态栏 -->
      <div class="status-bar" v-if="deviceData.videoName">
        <span class="label">正在播放:</span>
        <span class="value">{{ deviceData.videoName }}</span>
        <div class="playing-icon">
          <span></span><span></span><span></span>
        </div>
      </div>

   
      <!-- 视频网格 -->
      <div  class="video-grid">
        <div 
          v-for="(item, index) in videoList"
          :key="index"
          class="video-card"
          :class="{ 'active-playing': currentVideo === item.name }"
          @click="changeVideo(item)"
        >
          <div class="cover-box">
            <van-image :src="item.image" width="100%" height="100%" fit="cover" />
            <!-- 播放中遮罩 -->
            <div class="playing-mask" v-if="currentVideo === item.name">
              <span class="text">播放中</span>
            </div>
            <!-- 预览按钮 (阻止冒泡) -->
               <!-- 【修改点 1】：这里不再嵌套 VideoDialog，改为普通的点击事件 -->
            <div class="preview-btn" @click.stop="handlePreviewVideo(item)">
               <van-icon name="play-circle-o" color="#000" size="28" />
            </div>
          </div>
          <div class="info-box">
            <div class="title">{{ item.name }}</div>
            <div class="tags">
              <span class="tag">{{ item.category === '0' ? '讲解' : '示范' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- 【修改点 2】：新增全局视频预览弹窗 -->
    <!-- get-container="body" 是关键，它会把弹窗强制挂载到 body 节点，彻底解决层级遮挡问题 -->
    <van-popup 
      v-model="showPreviewPlayer" 
      get-container="body" 
      class="video-preview-popup"
      closeable
      close-icon="close"
      close-icon-position="top-right"
    >
      <div class="player-wrapper">
        <video 
          v-if="showPreviewPlayer"
          :src="currentPreviewUrl" 
          controls 
          style="width: 100%; height: 100%; object-fit: contain;border-radius: 20px; "
        ></video>
      </div>
      <!-- <div class="player-title">{{ currentPreviewTitle }}</div> -->
    </van-popup>
    <!-- 5. 底部设备选择弹窗 (卡片式布局) -->
    <van-popup 
      v-model="showDevicePopup" 
      position="bottom" 
      round 
      class="device-popup-container"
      :style="{ height: '75%' }"
    >
      <div class="popup-header">
        <!-- <div class="title"></div>
        <div class="close-btn" @click="showDevicePopup = false">
          <van-icon name="cross" size="20" />
        </div> -->
      </div>
      
      <!-- 搜索栏 -->
      <div class="popup-search" >
        <van-search v-model="searchText" placeholder="搜索设备名/IP" shape="round" />
      </div>

      <div class="popup-scroll-area">
        <!-- 分组：在线设备 -->
        <div v-if="onlineDeviceList.length > 0">
          <div class="group-header">
            <span class="dot green"></span>在线设备 ({{ onlineDeviceList.length }})
          </div>
          <div class="device-card-grid">
            <div 
              v-for="item in onlineDeviceList" 
              :key="item.code"
              class="device-grid-item online"
              :class="{ 'selected': deviceData.code === item.code }"
              @click="handleSelectDevice(item)"
            >
              <div class="card-top">
                <span class="status-badge">在线</span>
                <van-icon v-if="deviceData.code === item.code" name="success" color="#007AFF" />
              </div>
              <div class="card-main">
                <div class="name">{{ item.remark }}</div>
                <div class="ip">{{ item.ip || 'No IP' }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 分组：离线设备 -->
        <div v-if="offlineDeviceList.length > 0" style="margin-top: 20px;">
          <div class="group-header">
            <span class="dot gray"></span>离线设备 ({{ offlineDeviceList.length }})
          </div>
          <div class="device-card-grid">
            <div 
              v-for="item in offlineDeviceList" 
              :key="item.code"
              class="device-grid-item offline"
              @click="handleSelectDevice(item)"
            >
              <div class="card-top">
                <span class="status-badge">离线</span>
              </div>
              <div class="card-main">
                <div class="name">{{ item.remark }}</div>
                <div class="time">{{ formatLastTime(item.lastOnlineTime) }}</div>
              </div>
            </div>
          </div>
        </div>

        <van-empty v-if="deviceList.length === 0" description="暂无设备数据" />
      </div>
    </van-popup>

  </div>
</template>

<script>
import { Dialog } from 'vant';
import { 
  selectSchoolDeviceList,
  selectSchoolDeviceStatus,
  selectSchoolDeviceProjectCodeList,
  updateDeviceVideoName
} from "@/api/teacher/deviceControlVideo.js";
import VideoDialog from "@/components/VideoDialog.vue";
import moment from 'moment';

export default {
  name: 'VideoControlCardStyle',
  components: { VideoDialog },
  data() {
    return {
      teacherTitleInfo: {},
      showDevicePopup: false,
      searchText: '',
      deviceList: [],
      deviceData: {}, // 当前选中的设备详情
      currentVideo: '',
      videoList: [
        {name:'肺活量讲解', number:'10', category:'0', remark:"备注说明", image:require('../../videoMgt/img/cover1.png'), videoUrl:"https://cppu.xtotoro.com/longmao/video/肺活量讲解.mp4"},
        {name:'立定跳远讲解', number:'10', category:'0', remark:"备注说明", image:require('../../videoMgt/img/cover1.png'), videoUrl:"https://cppu.xtotoro.com/longmao/video/立定跳远讲解.mp4"},
        {name:'实心球讲解', number:'10', category:'0', remark:"备注说明", image:require('../../videoMgt/img/cover1.png'), videoUrl:"https://cppu.xtotoro.com/longmao/video/实心球讲解.mp4"},
        {name:'跳绳讲解', number:'10', category:'0', remark:"备注说明", image:require('../../videoMgt/img/跳绳.png'), videoUrl:"https://cppu.xtotoro.com/longmao/video/跳绳运动讲解.mp4"},
        {name:'仰卧起坐讲解', number:'10', category:'0', remark:"备注说明", image:require('../../videoMgt/img/cover1.png'), videoUrl:"https://cppu.xtotoro.com/longmao/video/仰卧起坐讲解.mp4"},
        {name:'引体向上讲解', number:'10', category:'0', remark:"备注说明", image:require('../../videoMgt/img/cover1.png'), videoUrl:"https://cppu.xtotoro.com/longmao/video/引体向上讲解.mp4"},
        {name:'坐位体前屈讲解', number:'10', category:'0', remark:"备注说明", image:require('../../videoMgt/img/cover1.png'), videoUrl:"https://cppu.xtotoro.com/longmao/video/坐位体前屈讲解.mp4"},
        {name:'立定跳远示范', number:'10', category:'1', remark:"备注说明", image:require('../../videoMgt/img/cover1.png'), videoUrl:"https://cppu.xtotoro.com/longmao/video/立走跳远动作示范.mp4"},
        {name:'引体向上示范', number:'10', category:'1', remark:"备注说明", image:require('../../videoMgt/img/cover1.png'), videoUrl:"https://cppu.xtotoro.com/longmao/video/引体向上动作示范.mp4"},
        {name:'坐位体前屈示范', number:'10', category:'1', remark:"备注说明", image:require('../../videoMgt/img/cover1.png'), videoUrl:"https://cppu.xtotoro.com/longmao/video/坐位体前屈动作示范.mp4"},
        {name:'实心球示范', number:'10', category:'1', remark:"备注说明", image:require('../../videoMgt/img/cover1.png'), videoUrl:"https://cppu.xtotoro.com/longmao/video/实心球动作示范.mp4"},
        {name:'仰卧起坐示范', number:'10', category:'1', remark:"备注说明", image:require('../../videoMgt/img/cover1.png'), videoUrl:"https://cppu.xtotoro.com/longmao/video/仰卧起坐示范跟练.mp4"},
        {name:'跳绳示范', number:'10', category:'1', remark:"备注说明", image:require('../../videoMgt/img/跳绳.png'), videoUrl:"https://cppu.xtotoro.com/longmao/video/跳绳运动示范跟练.mp4"},
      ],
      isVideoPlay: false,
          // 【新增】控制视频预览的数据
      showPreviewPlayer: false,
      currentPreviewUrl: '',
      currentPreviewTitle: ''
    };
  },
  computed: {
    filteredList() {
      if (!this.searchText) return this.deviceList;
      return this.deviceList.filter(item => {
        const str = (item.remark + item.ip).toLowerCase();
        return str.includes(this.searchText.toLowerCase());
      });
    },
    onlineDeviceList() {
      return this.filteredList.filter(item => this.isOnline(item));
    },
    offlineDeviceList() {
      return this.filteredList.filter(item => !this.isOnline(item));
    }
  },
  mounted() {
    try {
      this.teacherTitleInfo = JSON.parse(sessionStorage.getItem('teacherTitleInfo') || '{}');
      this.getList();
    } catch (e) { console.error(e) }
  },
  methods: {
     // 【新增】点击预览按钮触发的方法
    handlePreviewVideo(item) {
      this.currentPreviewUrl = item.videoUrl;
      this.currentPreviewTitle = item.name;
      this.showPreviewPlayer = true;
    },
    
    // 如果需要弹窗关闭时停止视频（v-if 已经处理了销毁，这里只是双重保险）
    onPreviewClose() {
      this.currentPreviewUrl = '';
    },
    // 判断是否在线 (后端已按"心跳时间窗优先 + MQTT onlineStatus 兜底"统一判定，对象入参直接采用后端结果；纯时间入参保留本地时间窗判定)
    isOnline(deviceOrTime) {
      if (!deviceOrTime) return false;
      if (typeof deviceOrTime === 'object' && !(deviceOrTime instanceof Date)) {
        const status = deviceOrTime.onlineStatus;
        if (status !== undefined && status !== null && status !== '') {
          return status === '1' || status === 1;
        }
        const time = deviceOrTime.lastOnlineTime;
        if (time && moment(time).isValid()) {
          const diffMinutes = moment().diff(moment(time), 'minutes');
          return diffMinutes >= -5 && diffMinutes < 10;
        }
        return false;
      }
      if (!moment(deviceOrTime).isValid()) return false;
      const diffMinutes = moment().diff(moment(deviceOrTime), 'minutes');
      return diffMinutes >= -5 && diffMinutes < 10;
    },
    // 格式化状态显示
    formatStatus(deviceOrTime) {
      if (!this.isOnline(deviceOrTime)) return '离线';
      return '在线';
    },
    // 格式化时间
    formatLastTime(time) {
      if (!time) return '--';
      if (moment(time).isSame(moment(), 'day')) {
        return moment(time).format('HH:mm');
      }
      return moment(time).format('MM-DD');
    },
    
    getList() {
      selectSchoolDeviceList({
        userId: this.teacherTitleInfo.teacherId,
        userName: this.teacherTitleInfo.teacherName,
        schoolCode: this.teacherTitleInfo.schoolCode,
        projectCode: 'tiaotiao',
      }).then(res => {
        if(res.data && res.data.body){
          // 排序：在线在前，离线在后
          this.deviceList = res.data.body.sort((a,b) => {
             const aOnline = this.isOnline(a) ? 1 : 0;
             const bOnline = this.isOnline(b) ? 1 : 0;
             return bOnline - aOnline;
          });
          // 默认选中第一个在线的
          const first = this.deviceList[0];
          if (first) {
            this.handleSelectDevice(first, false); // false表示不关闭弹窗(初始化)
          }
        }
      });
    },

    openDevicePopup() {
      this.showDevicePopup = true;
      this.searchText = '';
    },

    async handleSelectDevice(item, closePopup = true) {
      if (closePopup) this.showDevicePopup = false;
      
      // 设置基础数据
      this.deviceData = item;
      
      if (closePopup) {
         this.$toast.loading({ message: '同步设备状态...', forbidClick: true });
      }

      try {
        // 获取实时状态（当前播放视频名等）
        const res = await selectSchoolDeviceStatus({ deviceId: item.code, schoolCode: item.schoolCode });
        // 合并数据
        this.deviceData = { ...item, ...res.data.body };
        this.currentVideo = this.deviceData.videoName || '';
        
        // 检查是否支持视讯 (可选逻辑)
   // 检查项目类型
      const ProjectCodeList = await selectSchoolDeviceProjectCodeList({
        deviceId: this.deviceData.code,
        schoolCode: this.teacherTitleInfo.schoolCode,
        checkType: '2'
      });
      
      this.projectList = ProjectCodeList.data.body || [];
      this.isVideoPlay = false;
      // 检查返回列表中是否有 VideoPlay 项目，或者当前 chooseProjectCode 是 VideoPlay
      if (this.projectList.some(el => el.projectCode == "VideoPlay") || this.deviceData.chooseProjectCode == 'VideoPlay') {
        this.isVideoPlay = true;
      }











        if (closePopup) this.$toast.clear();
      } catch (e) {
        if (closePopup) this.$toast.fail('状态同步失败');
      }
    },

    changeVideo(item) {
      if (!this.deviceData.code) return this.$toast('请先选择设备');
      
      Dialog.confirm({
        title: '切换播放',
        message: `在 [${this.deviceData.remark}] 播放\n${item.name} ?`,
        confirmButtonColor: '#007AFF'
      }).then(() => {
        updateDeviceVideoName({
          deviceId: this.deviceData.code,
          videoName: item.name
        }).then(() => {
          this.$toast.success('指令已发送');
          this.currentVideo = item.name;
          this.deviceData.videoName = item.name;
        });
      }).catch(()=>{});
    }
  }
};
</script>

<style lang="less" scoped>
/* ---------------- 基础页面样式 ---------------- */
.ios-glass-page {
  min-height: 100vh;
  background: radial-gradient(circle at top left, #f1f3f9, #dfe4ea);
  padding: 16px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, sans-serif;
  padding-bottom: 40px;
}

/* 动态背景 */
.background-blobs {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 0; pointer-events: none;
  .blob { position: absolute; border-radius: 50%; filter: blur(60px); opacity: 0.5; }
  .blob-1 { width: 220px; height: 220px; background: #cce0ff; top: -50px; left: -50px; }
  .blob-2 { width: 200px; height: 200px; background: #e0f2f1; top: 30%; right: -50px; }
}

.page-header {
  position: relative; z-index: 1; margin-bottom: 24px;
  .header-title { font-size: 26px; font-weight: 800; color: #1c1c1e; margin: 0; }
  .header-subtitle { font-size: 13px; color: #8e8e93; letter-spacing: 0.5px; margin-top: 4px; }
}

.section-label {
  position: relative; z-index: 1;
  font-size: 14px; font-weight: 600; color: #6e6e73;
  margin: 20px 0 10px 4px;
  text-transform: uppercase;
}

/* ---------------- 3. 当前设备主卡片 ---------------- */
.current-device-card {
  position: relative; z-index: 1;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 18px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.06);
  border: 1px solid rgba(255,255,255,0.9);
  transition: transform 0.1s;
  
  &:active { transform: scale(0.98); background: #fff; }

  .card-content {
    display: flex; align-items: center;
  }

  /* 图标 */
  .device-icon-box {
    width: 48px; height: 48px;
    background: #d1d1d6;
    border-radius: 14px;
    display: flex; align-items: center; justify-content: center;
    margin-right: 14px; position: relative;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);

    &.online { background: #34C759; box-shadow: 0 4px 12px rgba(52, 199, 89, 0.4); }

    .pulse-ring {
      position: absolute; width: 100%; height: 100%; border-radius: 14px;
      border: 2px solid #34C759; opacity: 0;
      animation: ripple 2s infinite;
    }
  }

  .device-info {
    flex: 1;
    .device-name { font-size: 17px; font-weight: 700; color: #1c1c1e; margin-bottom: 4px; }
    .device-status-text {
      font-size: 13px; color: #8e8e93;
      .dot { margin: 0 4px; font-weight: bold; }
      .text-green { color: #34C759; }
    }
  }

  .switch-btn {
    display: flex; align-items: center; font-size: 13px; color: #007AFF; font-weight: 500;
  }
}

/* ---------------- 4. 视频列表 ---------------- */
.video-container { position: relative; z-index: 1; }

.status-bar {
  margin-top: 20px;
  display: flex; align-items: center; margin-bottom: 12px; font-size: 13px;
  .label { color: #8e8e93; margin-right: 6px; }
  .value { color: #007AFF; font-weight: 600; margin-right: 8px; }
  .playing-icon span {
    display: inline-block; width: 3px; background: #007AFF; margin-right: 2px;
    animation: bounce 1s infinite;
    &:nth-child(1) { height: 8px; animation-delay: 0s; }
    &:nth-child(2) { height: 12px; animation-delay: 0.2s; }
    &:nth-child(3) { height: 6px; animation-delay: 0.4s; }
  }
}

.video-grid {
  display: grid; grid-template-columns: repeat(2, 1fr); gap: 14px;
}

.video-card {
  background: rgba(255,255,255,0.8); border-radius: 12px; overflow: hidden;
  box-shadow: 0 2px 10px rgba(0,0,0,0.03); transition: all 0.2s;
  border: 2px solid transparent;

  &.active-playing {
    border-color: #007AFF; background: #fff; box-shadow: 0 4px 16px rgba(0,122,255,0.2);
  }

  .cover-box {
    height: 100px; position: relative; background: #eee;
    .playing-mask {
      position: absolute; top:0; left:0; width:100%; height:100%;
      background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center;
      .text { color: #fff; font-size: 12px; font-weight: 600; padding: 4px 10px; border: 1px solid #fff; border-radius: 20px;}
    }
    .preview-btn {
      position: absolute; bottom: 6px; right: 6px; z-index: 2;
      opacity: 0.9;
    }
  }

  .info-box {
    padding: 10px;
    .title { font-size: 14px; font-weight: 600; color: #333; margin-bottom: 6px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .tag { font-size: 10px; background: #f2f2f7; color: #8e8e93; padding: 2px 6px; border-radius: 4px; }
  }
}
/* 空状态卡片 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: #8e8e93;
  font-size: 14px;
  margin-top: 20px;

  p { margin: 10px 0 4px; }
  .sub-tip { font-size: 12px; opacity: 0.7; }
}
/* ---------------- 5. 弹窗样式 (核心修改：网格卡片) ---------------- */
.device-popup-container {
  display: flex; flex-direction: column; background: #f9f9fb;
}
.popup-header {
   background: #fff; display: flex; justify-content: space-between; align-items: center;
  .title { font-size: 17px; font-weight: 600; }
  .close-btn { 
    // position: absolute;
    // right: 0px;
    // top: 10px;
    width: 30px; height: 30px; background: #f2f2f7; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #8e8e93; }
}
.popup-search { padding: 0 12px 10px; background: #fff; border-bottom: 1px solid #eee; }

.popup-scroll-area {
  flex: 1; overflow-y: auto; padding: 16px;
}

.group-header {
  font-size: 13px; color: #8e8e93; margin-bottom: 10px; display: flex; align-items: center;
  .dot { width: 6px; height: 6px; border-radius: 50%; margin-right: 6px; }
  .green { background: #34C759; }
  .gray { background: #c7c7cc; }
}

/* 弹窗内的卡片网格 */
.device-card-grid {
  display: grid; 
  grid-template-columns: 1fr 1fr; /* 双列 */
  gap: 12px;
}

.device-grid-item {
  background: #fff;
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.02);
  border: 2px solid transparent;
  transition: all 0.2s;

  /* 选中态 */
  &.selected {
    border-color: #007AFF;
    background: #f0f8ff;
    .name { color: #007AFF !important; }
  }

  /* 在线态 */
  &.online {
    &:active { transform: scale(0.96); background: #fafafa; }
    .card-top .status-badge { background: #e8f5e9; color: #34C759; }
    .name { color: #333; }
  }

  /* 离线态 */
  &.offline {
    opacity: 0.7; background: #f5f5f5;
    .card-top .status-badge { background: #eee; color: #999; }
    .name { color: #999; }
  }

  .card-top {
    display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;
    .status-badge { font-size: 10px; padding: 2px 6px; border-radius: 4px; font-weight: 500; }
  }

  .card-main {
    .name { font-size: 14px; font-weight: 600; margin-bottom: 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .ip, .time { font-size: 11px; color: #8e8e93; }
  }
}
/* 【新增】视频预览弹窗样式 */


 
.video-preview-popup {
  width: 100%;
  height: 100%; /* 全屏 */
  background-color: #e4e2e21c; /* 黑色背景 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

   .player-wrapper {
    width: calc(100% - 80px);
    padding: 24px 20px;
    margin: 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;

    // 【关键点2】磨玻璃核心样式
    // 半透明白色背景
    background: rgba(255, 255, 255, 0.15); 
    // 背景模糊 (Glass effect)
    backdrop-filter: blur(12px) saturate(180%);
    -webkit-backdrop-filter: blur(12px) saturate(180%); // 兼容 iOS
    
    // 边框与圆角
    border-radius: 20px; // 大圆角
    border: 1px solid rgba(255, 255, 255, 0.8); // 加上一道淡淡的白边，增强质感
    
    // 柔和的投影，增加悬浮感
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15); 

 

    .popup-subtitle {
      font-size: 13px;
    //   color: #fff; // 稍微加深颜色以适应半透明背景
      margin-bottom: 24px;
    }

    .card-options {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 16px;

      .type-card {
        display: flex;
        align-items: center;
        padding: 16px;
        border-radius: 16px; // 卡片圆角也要跟上
        
        // 【关键点3】卡片样式微调
        // 让卡片变成半透明白色，与磨玻璃背景区分
        background: rgba(255, 255, 255, 0.6); 
        border: 1px solid rgba(255, 255, 255, 0.5);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
        
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        cursor: pointer;

        .icon-box {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          margin-right: 14px;
          flex-shrink: 0;
          // 图标背景也做一点渐变或通透处理
        }

      


      }
    }

    .cancel-text {
      margin-top: 24px;
      font-size: 13px;
    //   color: rgb(255, 255, 255); // iOS 风格灰色
      padding: 8px;
      letter-spacing: 1px;
    }
  }
  /* 自定义关闭按钮颜色 */
  ::v-deep .van-popup__close-icon {
    color: #fff;
    font-size: 24px;
    background: rgba(0,0,0,0.5);
    border-radius: 50%;
    padding: 4px;
    margin: 10px;
  }

  // .player-wrapper {
  //   width: 100%;
  //   height: 60%; /* 视频区域高度 */
  //   display: flex;
  //   align-items: center;
  //   background: #000;
  // }

  .player-title {
    color: #fff;
    font-size: 16px;
    margin-top: 20px;
    font-weight: 500;
  }
}
/* Mixin helper (less) */
.glass-container {
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 20px;
}
/* 动画 */
@keyframes ripple { 0% { transform: scale(1); opacity: 0.8; } 100% { transform: scale(1.4); opacity: 0; } }
@keyframes bounce { 0%, 100% { transform: scaleY(1); } 50% { transform: scaleY(1.5); } }
</style>